import { axiosInstance } from '../../../axios'
import { deserialiseResponse } from '../formatters'

export const ClientHomeService = {
  chat: async (params) => {
    const response = await axiosInstance.get('api/web/v1/client/home/chat', { params })
    return deserialiseResponse(response.data)
  },
  compliment: async () => {
    return await axiosInstance.get('api/web/v1/client/home/compliment')
  },
  fetchThread: async (params) => {
    const response = await axiosInstance.get('api/web/v1/client/home/thread', { params })
    return deserialiseResponse(response.data)
  },
  fetchThreads: async () => {
    const response = await axiosInstance.get('api/web/v1/client/home/threads')
    return formatDatasets(deserialiseResponse(response.data))
  },
}

const formatDatasets = (datasets) => {
  return datasets.map(formatDataset)
}

const formatDataset = (dataset) => {
  const { attributes, ...rest } = dataset
  return { ...attributes, ...rest }
}
